import React from 'react'
import NavBar from '../Component/NavBarFooter/NavBar'
import Footer from '../Component/NavBarFooter/Footer'
import Banner from '../Component/OurMission/Banner'
import AboutSection from '../Component/OurMission/AboutSection'
import OurTeam from '../Component/OurMission/OurTeam'

function OurMission() {
  return (
       <div>
           <NavBar/>
            <Banner/>
            <AboutSection/>
            {/* <OurTeam/> */}
           <Footer/>
   
       </div>
  )
}

export default OurMission